export enum TaskActionType {
  MarkDone = 'MarkDone',
  Pend = 'Pend',
  Route = 'Route',
  EditNote = 'EditNote',
  Skip = 'Skip',
  History = 'History',
  EditProject = 'EditProject'
}

export enum EventType {
  Create = 'Create',
  Update = 'Update',
  Skip = 'Skip',
  Complete = 'Complete',
  Start = 'Start',
  Delete = 'Delete',
  Option1 = 'Option1',
  Option2 = 'Option2',
  Option3 = 'Option3',
  Option4 = 'Option4',
  Option5 = 'Option5',
  Option6 = 'Option6',
  Option7 = 'Option7'
}

//List of all events that can be referenced in validation rules for this object
export const TaskObjectValidationEvents: EventType[] = [EventType.Create, EventType.Complete, EventType.Skip];

export enum TaskHeaderLayoutType {
  SingleRow = 'SingleRow',
  TaskDesc = 'TaskDesc',
  Normal = 'Normal'
}

export class TaskHeaderType {
  Default_Layout?: TaskHeaderLayoutType;
  Current_Layout?: TaskHeaderLayoutType;
  Task_Desc_Lines?: string;
}
